import React from "react";
import classnames from "classnames";

/**
 * components that renders iconst from the sprite
 * file in 'learn-icons/sprite'
 */
const SvgIcon = ({ iconName, className }) => {
  return (
    <svg className={classnames("svg-icon", { [className]: className })}>
      <use xlinkHref={`/learn-icons/sprite/sprite.svg#icon-${iconName}`}></use>
    </svg>
  );
};

export default SvgIcon;
